//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { date } from "quasar";

export default {
    name: "AQDatetime",
    props: {
        name: String, // Date && time ///Used to specify the name of the control; Useful if dealing with forms submitted directly to a URL
        landscape: Boolean, // Date && time /// Display the component in landscape mode
        yearsInMonthView: Boolean, // Date only ///Show the years selector in months view
        title: String, // Date && time /// When specified, it overrides the default header title; Makes sense when not in 'minimal' mode
        subtitle: String, // Date picker /// When specified, it overrides the default header subtitle; Makes sense when not in 'minimal' mode
        todayBtn: Boolean, // Date picker /// Display a button that selects the current day
        minimal: Boolean, // Date picker /// Don’t display the header
        value: [String, Array, Object], // Date && time /// Date(s) of the component; Must be Array if using 'multiple' prop;
        /// ///////////////////////////////////////////// Either use this property (along with a listener for 'input' event) OR use v-model directive
        mask: String, // Date && time // Mask (formatting string) used for parsing and formatting value
        locale: Object, // Locale formatting options
        calendar: String, // Date && time //Specify calendar type
        defaultView: String, // The view which will be displayed by default
        events: [Array, Function], // A list of events to highlight on the calendar; If using a function,
        /// ///////////////////////// it receives the date as a String and must return a Boolean (matches or not); If using a function
        /// ///////////////////////// then for best performance, reference it from your scope and do not define it inline
        options: [Array, Function], // Date only(for time use: hourOptions, minuteOptions, secondOptions).
        /// ////////////////////////// Optionally configure the days that are selectable; If using a function,
        /// ////////////////////////// it receives the date as a String and must return a Boolean (is date acceptable or not);
        /// //////////// ///////////// If using a function then for best performance, reference it from your scope and do not define it inline;
        /// //////////// ///////////// Incompatible with 'range' prop
        multiple: Boolean, // Allow multiple selection; Model must be Array
        range: Boolean, // Allow range selection; Partial compatibility with 'options' prop: selected ranges might also include 'unselectable' days
        emitImmediately: Boolean, // Emit model when user browses month and year too; ONLY for single selection (non-multiple, non-range)
        navigationMinYearMonth: String, // Lock user from navigating below a specific year+month (in YYYY/MM format);
        /// ////////////////////////////// This prop is not used to correct the model; You might want to also use 'default-year-month' prop
        navigationMaxYearMonth: String, // Lock user from navigating above a specific year+month (in YYYY/MM format);
        /// ////////////////////////////// This prop is not used to correct the model; You might want to also use 'default-year-month' prop
        noUnset: Boolean, // Remove ability to unselect a date; It does not apply to selecting a range over already selected dates
        readonly: Boolean, // Put component in readonly mode
        disable: Boolean, // Put component in disabled mode
        color: String, // Color name for component from the Quasar Color Palette
        textColor: String, // Overrides text color (if needed); Color name from the Quasar Color Palette
        dark: Boolean, // Notify the component that the background is a dark color
        square: Boolean, // Removes border-radius so borders are squared
        flat: Boolean, // Applies a 'flat' design (no default shadow)
        bordered: Boolean, // Applies a default border to the component
        eventColor: [String, Function], // Color name (from the Quasar Color Palette); If using a function, it receives the date as a String
        /// ////////////////////////////// and must return a String (color for the received date); If using a function then for best performance,
        /// ////////////////////////////// reference it from your scope and do not define it inline
        format24h: Boolean, // time only ///// Forces 24 hour time display instead of AM/PM system
        hourOptions: Array, // time only ///// Optionally configure what hours is the user allowed to set; Overrides 'options' prop if that is also set
        minuteOptions: Array, // time only ///// Optionally configure what minutes is the user allowed to set; Overrides 'options' prop if that is also set
        secondOptions: Array, // time only ///// Optionally configure what seconds is the user allowed to set; Overrides 'options' prop if that is also set
        withSeconds: Boolean, // time only ///// Allow the time to be set with seconds
        nowBtn: Boolean, // time only ///// Display a button that selects the current time
        defaultDate: String, // The default date to use (in YYYY/MM/DD format) when model is unfilled (undefined or null)

        /// ///////////////////////
        type: { type: String, default: "datetime" },
        staticBadge: { type: String, default: "" },
        condensed: { type: Boolean, default: true },
        error: { type: Boolean, default: false },
        errorLabel: { type: String, default: "" },
        label: { type: String, default: "" },
        open: { type: Boolean, default: false },
        noTimeOptions: { type: Boolean, default: false } // reset options from props when show qtime
    },
    data() {
        return {
            date: String(+new Date(this.value)),
            time: null,
            isFocused: false,
            showDate: false,
            showTime: false,
            qTimeProps: {}
        };
    },
    computed: {
        defaultDateForTime() {
            if (this.type === "datetime") {
                return date.formatDate(new Date(+this.date), "YYYY/MM/DD");
            }
            return date.formatDate(new Date(), "YYYY/MM/DD");
        },
        defaultYearMonth() {
            if (this.value) {
                return date.formatDate(new Date(this.date), "YYYY/MM");
            }
            return date.formatDate(new Date(), "YYYY/MM");
        }
    },
    created() {
        this.resetShows();
    },
    methods: {
        emitValue(newVal) {
            this.$emit("input", newVal);
        },
        resetShows() {
            if (this.type !== "time") {
                this.showDate = true;
            }
            if (this.type !== "date") {
                this.showTime = true;
            }
        },
        onDateInput(newValue, reason) {
            if (reason === "add-day") {
                this.date = newValue;
                this.emitValue(this.date);
                this.$refs.qDate.hide();
            }
            if (this.type === "datetime") {
                this.showDate = false;
                this.showNext();
            }
        },
        onTimeInput(newValue) {
            this.emitValue(newValue);
            this.$refs.qTime.hide();
            this.resetShows();
            this.$emit("closeTimeModal");
        },
        showNext() {
            if (this.disable) {
                return;
            }
            if (this.showDate) {
                this.$refs.qDate.show();
                return;
            }
            if (this.showTime) {
                this.time = null;
                this.qTimeProps = { ...this.$props };
                if (this.$props.noTimeOptions) {
                    this.qTimeProps.options = undefined;
                }
                this.$refs.qTime.show();
                this.resetShows();
            }
        }
    }
};
